import { Address } from '@dgx-pr-spa/shared/util';
import { DeliveryDates, OfferDeliveryDates } from '@dgx-pr-spa/shared/util';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { CompleteOrderBackendService } from '@complete-order/services/complete-order-backend.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromOffersDeliveryDates from '../actions/offers.delivery.dates.action';
import { map, withLatestFrom, mergeMap, first } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
@Injectable()
export class DeliveryDatesEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly viewOffersService: ViewOffersService,
    public readonly buildConfigService: BuildConfigService,
    public readonly completeOrderService: CompleteOrderService,
    public readonly completeOrderBackend: CompleteOrderBackendService
  ) {}

  loadDeliveryDates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromOffersDeliveryDates.loadOffersDeliveryDates),
      map(({ payload }) => payload),
      withLatestFrom(
        this.viewOffersService.offerReference$,
        this.viewOffersService.deliveryAddress$
      ),
      mergeMap(([replacement, reference, delivery]) =>
        this.viewOffersService
          .selectOffersDeliveryDatesById$(
            `${replacement.supplier_id}/${replacement.cat_num}`
          )
          .pipe(
            first(),
            map((entityDates) => [
              replacement,
              reference,
              delivery,
              entityDates,
            ])
          )
      ),

      mergeMap(
        ([replacement, reference, delivery, entityDates]: [
          ReplacementOffer,
          string,
          Address,
          OfferDeliveryDates
        ]) => {
          const { supplier_id, cat_num } = replacement;
          const { postal_code } = delivery;
          const queryParams = `?postCode=${postal_code}&supplierId=${supplier_id}&catNum=${cat_num}`;

          if (!entityDates?.data && reference) {
            return this.completeOrderBackend
              .fetchDeliveryDates(
                `${this.buildConfigService.config.pr}/v2/offers/deliverydates`,
                {
                  offer_reference: `${reference}`,
                  post_code: `${postal_code}`,
                  supplier_id: supplier_id,
                  cat_num: `${cat_num}`,
                  service_cat_numbers: null,
                }
              )
              .pipe(
                map((response) => {
                  return fromOffersDeliveryDates.addOfferDeliveryDates({
                    payload: {
                      data: response as DeliveryDates,
                      supplier_id,
                      cat_num,
                    },
                  });
                })
              );
          } else {
            return EMPTY;
          }
        }
      )
    )
  );
}
